import {
  Component, Inject, OnDestroy, OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogRef,
} from '@angular/material/dialog';import { CourseRequestsService } from 'src/app/services/course-requests.service';

@Component({
  selector: 'app-course-request-details',
  templateUrl: './course-request-details.component.html',
  styleUrls: [ './course-request-details.component.scss' ],
})
export class CourseRequestDetailsComponent implements OnInit, OnDestroy {
  course: any = {
    courseRequestId: '',
    name: '',
    creditHours: '',
    courseType: '',
    instructor: '',
    cost: '',
    webUrl: '',
    description: '',
    async: false,
    virtual: false,
    anytime: false,
    location: '',
    roomNumber: '',
    courseDate: '',
    startTime: '',
    endTime: '',
  }
  isLoading: any;
  courseRequestSubscription: any;
  showUploadDocumentsModal = false;

  constructor(
    public dialogRef: MatDialogRef<CourseRequestDetailsComponent>,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
    private courseRequestsService: CourseRequestsService,
  ) { }

  ngOnInit(): void {
    this.loadCourseRequest();
  }

  loadCourseRequest(): void {
    this.isLoading = true;
    this.courseRequestSubscription = this.courseRequestsService.getCourseRequest(this.data.courseId).subscribe({
      next: (response: any) => {
        try {
          // The response structure: data is the course, data.CourseItems[0] is the course item, data.CourseItems[0].Documents contains documents
          const course = response?.data || {};
          const courseItem = course?.CourseItems?.[0] || {};
          const documents = courseItem?.Documents || [];
          
          const isAsync = courseItem?.preRecordedOption === 'ASYNC';
          const isAnytime = courseItem?.preRecordedOption === 'ANYTIME';
          
          this.course = {
            ...course,
            ...courseItem,
            name: course?.courseName || '',
            creditHours: course?.trackingValue || '',
            courseType: course?.CourseType?.courseType || course?.courseType || '',
            instructor: courseItem?.instructor || null,
            cost: course?.courseCost || null,
            webUrl: courseItem?.hyperlink || null,
            description: course?.courseDescription || '',
            async: isAsync,
            virtual: courseItem?.virtualFlag === 1,
            anytime: isAnytime,
            location: courseItem?.location || '',
            roomNumber: courseItem?.roomNumber || null,
            courseDate: isAsync ? 'Async' : (courseItem?.dateOffered ? new Date(courseItem.dateOffered).toLocaleDateString() : ''),
            startTime: isAnytime ? 'Anytime' : (courseItem?.sessionStartDate ? new Date(courseItem.sessionStartDate).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : ''),
            endTime: isAnytime ? 'Anytime' : (courseItem?.sessionEndDate ? new Date(courseItem.sessionEndDate).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : ''),
            // Include Documents from CourseItems[0].Documents
            Documents: documents,
            // Ensure CourseItems is included for getCourseItemId()
            CourseItems: course?.CourseItems || [],
            // Preserve both IDs - courseItemId is from courseItem.id, courseId is from course.id
            courseItemId: courseItem?.id || null,
            courseId: course?.id || courseItem?.courseId || null,
          }
        } catch (error) {
          console.error('Error processing course request data:', error);
        } finally {
          this.isLoading = false;
        }
      },
      error: (error: any) => {
        console.error('Error getting course request', error);
        this.isLoading = false;
      },
    });
  }

  onDocumentsUploaded(): void {
    // Reload course request data to refresh document list
    this.loadCourseRequest();
  }

  getCourseItemId(): number | null {
    if (this.course?.courseItemId) {
      return Number(this.course.courseItemId);
    }
    if (this.course?.CourseItems) {
      if (Array.isArray(this.course.CourseItems) && this.course.CourseItems.length > 0) {
        return Number(this.course.CourseItems[0].id);
      }
      if (typeof this.course.CourseItems === 'object') {
        return Number(this.course.CourseItems.id);
      }
    }
    if (this.course?.id) {
      return Number(this.course.id);
    }
    if (this.course?.course_item_id) {
      return Number(this.course.course_item_id);
    }
    return null;
  }

  openUploadDocumentsModal(): void {
    this.showUploadDocumentsModal = true;
  }

  closeUploadDocumentsModal(): void {
    this.showUploadDocumentsModal = false;
  }

  closeModal(action?: 'approve' | 'deny'): void {
    this.dialogRef.close(action);
  }

  ngOnDestroy(): void {
    this.courseRequestSubscription.unsubscribe();
  }

}
